import { useMemo } from 'react'
import { useInView } from 'react-intersection-observer'

import MarkdownRender from 'LuxKit/MarkdownRender'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

import { hasMapCoordinates } from './mapCoordinates'
import OfferPropertySurroundings from './OfferPropertySurroundings'

interface Props {
  offerId: string | undefined
  latitude: number | undefined
  longitude: number | undefined
  controlContent?: string
}

function OfferPropertySurroundingsActivationWrapper({
  offerId,
  latitude,
  longitude,
  controlContent,
}: Props) {
  const coordinates = useMemo(() => ({ latitude, longitude }), [latitude, longitude])
  const hasRequiredParams = !!offerId && hasMapCoordinates(coordinates)
  const [activationRef, hasMapBeenInView] = useInView({
    triggerOnce: true,
  })
  const { isAnyVariant: shouldShowSurroundings } = useExperiment(
    Experiments.croOfferNearbyLocations,
    { canActivate: hasRequiredParams && hasMapBeenInView },
  )

  if (!hasRequiredParams || !offerId || latitude === undefined || longitude === undefined) {
    if (controlContent) {
      return <MarkdownRender fontSize="medium" type="compact" content={controlContent} />
    }

    return null
  }

  if (!shouldShowSurroundings) {
    return (
      <div ref={activationRef}>
        {controlContent && <MarkdownRender fontSize="medium" type="compact" content={controlContent} />}
      </div>
    )
  }

  return (
    <div ref={activationRef}>
      <OfferPropertySurroundings
        offerId={offerId}
        latitude={latitude}
        longitude={longitude}
      />
    </div>
  )
}

export default OfferPropertySurroundingsActivationWrapper
